import _ from 'lodash'
import React, { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './index.css'
import { Icon } from '@vzmi/shp_shared_compo'

export const PickerArrow = (props) => {
  const { isOpen, className, onClick } = props
  return (
    <span
      key='arrow'
      onClick={onClick}
      data-role='arrow-zone'
      data-is-open={isOpen}
      className={cx(styles.PickerArrow, className, { [styles.isOpen]: isOpen })}
    >
      <Icon
        className={styles.arrow}
        name='caret-down'
        align='middle'
        size={16}
      />
    </span>
  )
}

class InputPicker extends PureComponent {
  render () {
    const {
      className,
      value,
      active,
      disabled,
      placeholder,
      ...restProps
    } = this.props
    const clz = cx('input-picker', styles.InputPicker, {
      [className]: !!className,
      [styles.opened]: active,
      [styles.disabled]: disabled
    })
    return (
      <div
        {...restProps}
        data-is-disabled={disabled}
        data-is-opened={active}
        className={clz}
      >
        <div
          data-role='selection'
          className={styles.selection}
        >
          <div
            key='selectedValue'
            data-role='selected-value'
            className={styles.selectedValue}
          >
            {
              _.isEmpty(value)
                ? (<span className={styles.placeholder}>{placeholder}</span>)
                : (value)
            }
          </div>
          <PickerArrow isOpen={active} />
        </div>
      </div>
    )
  }
}

InputPicker.defaultProps = {
  placeholder: '請選擇',
  active: false,
  'data-role': 'input-picker',
  onChange () { }
}

InputPicker.propTypes = {
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.string,
  active: PropTypes.bool,
  onChange: PropTypes.func,
  'data-role': PropTypes.string
}

export default InputPicker
